import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import Edges from '../components/Edges';
import * as theme from '../theme';

import PageIllustrations from '../assets/page-not-found.svg';

const NotFound = (props) => {
    let location = useLocation();

    return (
        <Edges size='md'>
            {location.state && location.state.errorMessage && (
                <Container>
                    <img src={PageIllustrations} />
                    <Headline children={'Page not found'} />
                    <ErrorMessage>
                        {location.state.errorMessage}. <a href='/'>Click here</a> to return to the main menu.
                    </ErrorMessage>
                </Container>
            )}
        </Edges>
    );
};

const Headline = styled.h1`
    text-align: center;
    color: ${theme.colors.primary};
    font-weight: 700;
`;

const ErrorMessage = styled.div`
    text-align: center;
    color: ${theme.colors.primary};
    margin-top: 10px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 35px;
    img {
        max-width: 25vw;
    }

    @media (max-width: 640px){
        padding: 10px 0px;
        img {
            max-width: 70vw;
        }
    }
`;

export default NotFound;
